<template>
    <!-- 自定义表单 -->
    <div class="contain" v-loading='isLoading'>
        <div class="left">
            <div class="tittle">流程</div>
            <div class="flowshList">
                <div class="flowshList_item" v-for='(item,index) in flowshList' :key="index">
                        <span @click="navClick(item)" :class="{'isChecked':item.isChecked,}">{{item.value}}</span>
                </div>
            </div>
        </div>
        <div class="right">
           <div class="tittle">字段</div>


           <div class="right_contain">
               <div class="card_item" v-for="(item,index) in currentNav.fieldList" :key="index">
                   <div class="card_tittle">{{item.fieldName}}</div>
                   <div>
                       <el-checkbox v-model="item.defaultMustFlag" :disabled="item.flexibleFlag==0" @change="defaultMustChange(item)">是否必填</el-checkbox>
                   </div>
               </div>
           </div>
        </div>
    </div>
</template>
<script>

import {
fieldDetail,//详情
saveFieldDetail,//保存
} from "@/api/v4ward/ordersetting/setting/selfForm";
export default {
    props:{
        option:{}
    },
    data(){
        return {
            isLoading:false,
            checked:false,
            currentNav:{},
            //流程列表
            flowshList:[
                {
                    actionType:0,
                    value:'我要报修',
                    isChecked:true,
                    fieldList:[
                    ]
                },
                {
                    actionType:1,
                    value:'派单',
                    isChecked:false,
                    fieldList:[
                    ]
                },
                {
                    actionType:2,
                    value:'抢单',
                    isChecked:false,
                    fieldList:[
                    ]
                },
                {
                    actionType:12,
                    value:'取消',
                    isChecked:false,
                    fieldList:[
                    ]
                },
                {
                    actionType:3,
                    value:'接受',
                    isChecked:false,
                    fieldList:[
                    ]
                },
                {
                    actionType:5,
                    value:'开始',
                    isChecked:false,
                    fieldList:[
                    ]
                },
                {
                    actionType:4,
                    value:'转办',
                    isChecked:false,
                    fieldList:[
                    ]
                },
                {
                    actionType:6,
                    value:'挂起',
                    isChecked:false,
                    fieldList:[
                    ]
                },
                {
                    actionType:7,
                    value:'挂起恢复',
                    isChecked:false,
                    fieldList:[
                    ]
                },
                {
                    actionType:16,
                    value:'协同',
                    isChecked:false,
                    fieldList:[
                    ]
                },
                {
                    actionType:14,
                    value:'报废',
                    isChecked:false,
                    fieldList:[
                    ]
                },
                {
                    actionType:15,
                    value:'外委',
                    isChecked:false,
                    fieldList:[
                    ]
                },
                {
                    actionType:8,
                    value:'维修完成',
                    isChecked:false,
                    fieldList:[
                    ]
                },

            ]
        }
    },
    created(){
        this.currentNav = this.flowshList[0]
        this.getFieldDetail(this.currentNav.actionType)
    },
    methods:{
        navClick(navItem){
            //切换导航栏 （单选操作）
            //1.统一赋值未选中状态
            this.flowshList.forEach(item=>{
                item.isChecked = false;

            })
             //2.点击的为选中
            navItem.isChecked = true
            //3.当前选中的导航栏赋值
            this.currentNav = navItem
            console.log("当前导航",this.currentNav)
            //4.请求接口获取表单数据
            //5.将数据插入到当前选中的导航中
            this.getFieldDetail(this.currentNav.actionType)
        },
        defaultMustChange(item){
            this.isLoading =true
            //必填状态切换
            console.log("item",item)
            let obj = {

                    id:item.id,
                    projectId:this.option.projectId,
                    mustFlag:item.defaultMustFlag?'1':'0',
                    visibleFlag:''

            }
            saveFieldDetail(obj).then(res=>{
                 this.isLoading =false
                 this.$message.success("保存成功")
            })
        },
        getFieldDetail(actionType){
            this.isLoading =true
            console.log('this.selfFormOption',this.option)
            let obj = {
                projectId:this.option.projectId,
                moduleType:this.option.moduleType,
                actionType:actionType
            }
            fieldDetail(obj).then(res=>{
                res.data.forEach(item=>{
                    if(item.defaultMustFlag == 1){
                        item.defaultMustFlag = true
                    }else{
                        item.defaultMustFlag = false
                    }
                })
                this.currentNav.fieldList = res.data
                this.isLoading =false

            })
        }
    }
}
</script>
<style lang="scss" scoped>
.contain{
    display: flex;
    .tittle{
        font-size: 28px;
        font-weight: bold;
        margin-bottom: 10px;
    }
    .left{
        padding: 0 40px;
        border-right: 1px solid;
    }
    .right{
        flex-grow: 1;
        padding: 0 40px;
        .right_contain{
            width: 100%;
            .card_item{
                width: 100%;
                background: #f5f6f8;
                padding: 16px;
                display: flex;
                flex-wrap: nowrap;
                margin-bottom: 20px;
                .card_tittle{
                    margin-right: 16px;
                    width: 100px;
                }
            }
        }
    }
}
.flowshList{
    .flowshList_item{
        margin-bottom: 10px;
        font-size: 16px;
        font-weight: bold;
        cursor:pointer;
        &:hover{

        }
        .isChecked{
            color: #409EFF;
        }
    }
}
</style>

